import intl from 'react-intl-universal';
import { useState, useMemo, useRef, useEffect } from 'react';
import { Image, Tabs, Tag } from 'antd';
import { default as Button } from '@/components/CssBtn';
import { default as Modal } from '@/components/CssModal';

import { getGoodsListByOrder, getGoodsListBySeriesName } from '@/api/common';

import {
    searchSeries,
    // searchProductBySeries as getGoodsListBySeriesName,
} from '@/api/systemSetting';

import { DynamicTable } from '@/components/index';

import { ProFormSelect } from '@ant-design/pro-components';

import type { ProColumnType } from '@ant-design/pro-components';
import type { FormItemValueType } from '@/components/index';
import defaultImg from '@/assets/default-logo.png';
import { isArray, debounce } from 'lodash';

const getTags = (
    labels: { label: string; color: string }[] = [],
    // record: any,
) => {
    return isArray(labels) && labels?.length ? (
        <div>
            {labels?.map((item) => {
                return (
                    <Tag
                        key={item.label}
                        color={item.color}
                    >
                        {item.label}
                    </Tag>
                );
            })}
            {/* {record.is_hidden && (
         <Tag
             key="hidden"
             color="#ab7ae0"
         >
             隐藏
         </Tag>
      )} */}
        </div>
    ) : (
        '-'
    );
};

interface Props {
    open: boolean;
    business_order_no?: string;
    goods?: any[];
    onClose: (isOpen: boolean) => void;
    onConfirm: (orders: string[]) => void;
}

const SelectGoods: React.FC<Props> = ({
    open,
    business_order_no,
    goods = [],
    onClose,
    onConfirm,
}) => {
    const tableRef = useRef();
    const formRef = useRef();

    const [selectGoods, setSelectGoods] = useState<any[]>([]);
    const currentSelectGoods = useRef([]);
    const [orderGoods, setOrderGoods] = useState([]);
    const [seriesLoading, setSeriesLoading] = useState(false);
    const [seriesValue, setSeriesValue] = useState<string>();
    const [series, setSeries] = useState([]);
    const [seriesGoods, setSeriesGoods] = useState([]);

    // const [disabled, setDisabled] = useState<boolean>(true);

    useEffect(() => {
        if (open && business_order_no) {
            getOrderGoods();
            initData();
        }
    }, [open]);

    const initData = () => {
        setSelectGoods(goods);
        if (goods && goods.length > 0) {
            currentSelectGoods.current = [...goods];
        }
        setSeries([]);
        setSeriesGoods([]);
        setSeriesValue('');
    };

    const SelectColumns = useMemo(
        () => [
            {
                title: intl.get('图片'),
                dataIndex: 'image',
                render: (text, record) => {
                    return (
                        <Image
                            src={record.image || defaultImg}
                            style={{ maxWidth: 60, maxHeight: 60 }}
                        ></Image>
                    );
                },
            },
            {
                title: intl.get('商品名称'),
                dataIndex: 'name',
            },
            {
                title: 'SKU',
                dataIndex: 'sku',
            },
            // {
            //     title: '发货仓',
            //     dataIndex: '1',
            // },
            // {
            //     title: '到货日期',
            //     dataIndex: 'date',
            // },
            {
                title: intl.get('操作'),
                dataIndex: 'op',
                render: (text, record, index) => {
                    return (
                        <Button
                            type="link"
                            onClick={() => onDelSelect(index)}
                        >
                            {intl.get('删除')}
                        </Button>
                    );
                },
            },
        ],

        [selectGoods],
    );

    const SeriesColumns = useMemo(
        () => [
            {
                title: intl.get('标签'),
                dataIndex: 'labels',
                width: 100,
                render: (labels, record) => {
                    return (
                        record.is_hidden && (
                            <Tag
                                key="hidden"
                                color="#ab7ae0"
                            >
                                {intl.get('隐藏')}
                            </Tag>
                        )
                    );
                },
            },
            {
                title: intl.get('图片'),
                dataIndex: 'img',
                width: 100,
                render: (text, record) => {
                    return (
                        <Image
                            src={record.toy_image || defaultImg}
                            style={{ maxWidth: 60, maxHeight: 60 }}
                        ></Image>
                    );
                },
            },
            {
                title: intl.get('名称'),
                dataIndex: 'toy_name',
            },
            {
                title: 'SKU',
                dataIndex: 'product_code',
            },
            {
                title: intl.get('上市时间'),
                dataIndex: 'putaway_time',
            },
            // {
            //     title: '库存',
            //     dataIndex: 'available_stock',
            // },
            // {
            //     title: '预计到货时间',
            //     dataIndex: 'arrival_time',
            // },
            {
                title: intl.get('包装类型'),
                dataIndex: 'packaging_type',
            },
        ],

        [],
    );

    const columns: ProColumnType<any, FormItemValueType>[] = useMemo(
        () => [
            {
                title: intl.get('商品名称'),
                dataIndex: 'name',
                width: 200,
                fixed: true,
            },
            {
                title: intl.get('标签'),
                dataIndex: 'labels',
                width: 100,
                // render: (
                //     labels: { label: string; color: string }[] = [],
                //     record,
                // ) => {
                //     return getTags(labels, record);
                // },
                render: (labels: { label: string; color: string }[] = []) => {
                    return getTags(labels);
                },
            },

            {
                title: intl.get('图片'),
                dataIndex: 'img',
                width: 100,
                render: (text, record) => {
                    return (
                        <Image
                            src={record.img || defaultImg}
                            style={{ maxWidth: 60, maxHeight: 60 }}
                        ></Image>
                    );
                },
            },
            {
                title: 'SKU',
                dataIndex: 'oms_no',
                width: 100,
            },
            {
                title: intl.get('上次换货商品'),
                dataIndex: ['aftersale_goods_info', 'lasted_swap_product_name'],
                width: 200,
            },
            {
                title: intl.get('商品类型'),
                dataIndex: 'category_name',
                width: 100,
            },
            {
                title: intl.get('商品系列'),
                dataIndex: 'series_name',
                width: 200,
            },
            {
                title: intl.get('商品金额'),
                dataIndex: 'original_price',
                width: 100,
            },
            {
                title: intl.get('数量'),
                dataIndex: 'num',
                width: 100,
            },
            {
                title: intl.get('属性'),
                dataIndex: 'product_type_str',
                width: 100,
            },
            {
                title: intl.get('玩法'),
                dataIndex: 'operation_method',
                width: 100,
            },
            {
                title: intl.get('服务期'),
                dataIndex: 'service_term',
                width: 150,
                render: (text, record) => {
                    if (record.service_overdue) {
                        return (
                            <div>
                                {text}
                                {intl.get('天')}{' '}
                                <span style={{ color: 'red' }}>
                                    {intl.get('已超期')}
                                    {record.service_overdue}
                                    {intl.get('天')}
                                </span>
                            </div>
                        );
                    }
                    return record.service_term
                        ? record.service_term + intl.get('天')
                        : '-';
                },
            },
        ],

        [],
    );

    const getOrderGoods = () => {
        getGoodsListByOrder({
            business_order_no,
        }).then((res) => {
            setOrderGoods(
                res?.goods_infos?.map((item) => {
                    return {
                        ...item,
                        children:
                            item.sub_goods_infos?.map((child: any) => ({
                                ...child,
                                is_child: true,
                            })) || undefined,
                    };
                }) || [],
            );
        });
    };

    // 搜索系列名
    const seriesSearch = debounce((series: string) => {
        if (!series) {
            return;
        }
        setSeriesLoading(true);
        searchSeries(series).then((result) => {
            if (result) {
                setSeries(
                    result?.slice?.(0, 100).map((item) => item.series_name) ||
                        [],
                );
            }
            setSeriesLoading(false);
        });
    }, 500);

    const getGoodsBySeries = async (series_name: string) => {
        const result = await getGoodsListBySeriesName(series_name);

        setSeriesValue(series_name);

        setSeriesGoods(result?.data || []);
    };

    const onDelSelect = (index: number) => {
        currentSelectGoods.current.splice(index, 1);
        setSelectGoods([...currentSelectGoods.current]);
    };

    const onSelect = (record: any, type: 1 | 0) => {
        if (record.is_compose) {
            return;
        }

        let goodItem = {
            image: record?.img,
            sku: record?.oms_no,
            name: record?.name,
        };

        if (type === 1) {
            goodItem = {
                image: record?.toy_image,
                sku: record?.product_code,
                name: record?.toy_name,
            };
        }

        setSelectGoods([...selectGoods, goodItem]);
        currentSelectGoods.current = [...selectGoods, goodItem];
    };

    const handleOk = () => {
        onConfirm(selectGoods);
        onClose?.(false);
    };

    const onCancel = () => {
        onClose?.(false);
    };

    const items = useMemo(
        () => [
            {
                key: '1',
                label: intl.get('订单商品'),
                children: (
                    <DynamicTable
                        className="modal_table"
                        actionRef={tableRef}
                        formRef={formRef}
                        columns={columns}
                        dataSource={orderGoods}
                        manualRequest={true}
                        search={false}
                        options={false}
                        pagination={false}
                        onRow={(record) => {
                            return {
                                onClick: () => {
                                    onSelect(record, 0);
                                },
                            };
                        }}
                        size="small"
                    ></DynamicTable>
                ),
            },
            {
                key: '2',
                label: intl.get('全系商品'),
                children: (
                    <>
                        <ProFormSelect
                            label={intl.get('系列名称')}
                            name="series"
                            // value={}
                            // colProps={{
                            //     span: 20,
                            // }}
                            fieldProps={{
                                value: seriesValue,
                                loading: seriesLoading,
                                showSearch: true,
                                showArrow: false,
                                filterOption: false,
                                options: series.map((item) => ({
                                    value: item,
                                    label: item,
                                })),
                                onSearch: seriesSearch,
                                onChange: getGoodsBySeries,
                                placeholder: intl.get('请输入系列名称'),
                            }}
                        />

                        <DynamicTable
                            className="modal_table"
                            actionRef={tableRef}
                            formRef={formRef}
                            dataSource={seriesGoods}
                            columns={SeriesColumns}
                            manualRequest={true}
                            search={false}
                            options={false}
                            pagination={false}
                            scroll={false}
                            onRow={(record) => {
                                return {
                                    onClick: () => {
                                        onSelect(record, 1);
                                    },
                                };
                            }}
                            size="small"
                        ></DynamicTable>
                    </>
                ),
            },
        ],

        [
            orderGoods,
            series,
            seriesGoods,
            seriesLoading,
            selectGoods,
            seriesValue,
        ],
    );

    return (
        <Modal
            title={intl.get('绑定商品，订单号：{business_order_no}', {
                business_order_no: business_order_no,
            })}
            open={open}
            width={1000}
            onOk={handleOk}
            onCancel={onCancel}
            destroyOnClose={true}
        >
            {/* <div>已选择订单：</div> */}
            <div>{intl.get('已选中商品：')}</div>
            <DynamicTable
                className="modal_table"
                actionRef={tableRef}
                formRef={formRef}
                columns={SelectColumns}
                dataSource={selectGoods}
                manualRequest={true}
                search={false}
                options={false}
                size="small"
                scroll={false}
                pagination={false}
            ></DynamicTable>
            <Tabs
                defaultActiveKey="1"
                items={items}
                destroyInactiveTabPane
            />
        </Modal>
    );
};

export default SelectGoods;
